import React, { useState } from 'react';
import styled from 'styled-components';
import { Chip } from '@mui/material';
import { IssueSelectInput } from '../IssueSelectInput';

const issueChipSx = {
  backgroundColor: '#E3F2FD',
  color: '#453DB7',
  '& .MuiChip-label': {
    color: '#453DB7'
  },
  '& .MuiChip-deleteIcon': {
    color: '#453DB7'
  }
};

const IssuesToCoverInput = ({
  onChange,
  disabled,
  value = []
}) => {
  const [issueInputValue, setIssueInputValue] = useState(null);

  const updateValue = nextValue => {
    onChange({
      target: {
        name: 'issuesToCover',
        value: nextValue
      }
    });
  };

  const selectedIssueKeys = value
    .map(item => item?.issue?.key)
    .filter(Boolean);

  return (
    <Wrapper>
      {value.map((item, index) => {
        const issue = item?.issue;
        if(!issue?.key) return null;

        return (
          <Chip
            key={issue.key}
            label={issue.name || issue.key}
            onDelete={disabled ? undefined : () => updateValue(value.filter((_, itemIndex) => itemIndex !== index))}
            size='small'
            sx={issueChipSx}
          />
        );
      })}
      {!disabled && (
        <IssueSelector>
          <IssueSelectInput
            candidateIssue={true}
            value={issueInputValue}
            excludeKeys={selectedIssueKeys}
            clearAfterSelect={true}
            onChange={e => {
              const selectedIssue = e.target.value;
              if(!selectedIssue?.key || selectedIssueKeys.includes(selectedIssue.key)) return;

              updateValue([
                ...value,
                {
                  issue: {
                    key: selectedIssue.key,
                    name: selectedIssue.name || selectedIssue.text
                  }
                }
              ]);
              setIssueInputValue(null);
            }}
          />
        </IssueSelector>
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding: 8px 0;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
`

const IssueSelector = styled.div`
  flex: 0 0 auto;
  min-width: 200px;
`;

export { IssuesToCoverInput, issueChipSx };
